module.exports = __webpack_public_path__ + "img/2.c3b5c2aa.jpg";